const comparators = {
    contains: 'rule.comparator.contains',
    equals: 'rule.comparator.eq',
    greaterThan: 'rule.comparator.gt',
    lessThan: 'rule.comparator.lt',
}

const operators = {
    and: 'rules.operator.and',
    or: 'rules.operator.or',
}

const types = {
    age: 'rules.type.age',
    checkbox: 'rules.type.checkbox',
    number: 'rules.type.number',
    radio: 'rules.type.radio',
    text: 'rules.type.text',
}

export {
    comparators,
    operators,
    types,
}